import React from "react";

export default function Contact() {
  return (
    <div className="max-w-2xl mx-auto text-center">
      <h2 className="text-3xl font-bold text-primary mb-4">Contact Us</h2>
      {/* <p className="mb-4">We’d love to hear from you!</p>
      <form className="space-y-4">
        <input type="text" placeholder="Name" className="w-full p-2 border rounded" />
        <input type="email" placeholder="Email" className="w-full p-2 border rounded" />
        <textarea placeholder="Message" className="w-full p-2 border rounded" rows="4"></textarea>
        <button type="submit" className="bg-primary text-white px-4 py-2 rounded shadow hover:bg-yellow-500">
          Send
        </button>
      </form> */}
      <p className="mt-6">
        📧 <a href="mailto:zhanar.nurbekovabm@gmail.com" className="text-secondary hover:underline">zhanar.nurbekovabm@gmail.com</a>
        <br />
        📞 <a href="tel:+14156974942" className="text-secondary hover:underline">(415) 697-4942</a>
      </p>
    </div>
  );
}